<template>
  <div style="background: #f7f7f7">
    <!--Telescopio 1-->
    <br />
    <br />
    <br />
    <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12" lg="6" class="pl-10">
          <!--Info Telescopio -->
           <br>
        <br>
        <br>
        <br>
          <p
            class="title font-weight-black text-center pt-3 pb-6"
            style="color: #777777"
          >REGINATO T700 NEWTON REFLECTOR</p>
          <v-divider></v-divider>
          <p 
            class="body-2 text-center pt-10 pb-10" 
            style="color: #777777"
            v-text="$t('descripciontelescopio[1]')">
          </p>
          <v-divider></v-divider>
          <div class="text-lg-center text-md-center text-sm-center text-center mt-4 mb-4">
            <v-btn 
              small 
              class="caption white--text" 
              color="#E8175D"
              @click="dialog = true"
              v-text="$t('especificacionestenicas[0]')">
              </v-btn>
          </div>
          <!--Fin Info Telescopio -->
        </v-col>
        <v-col cols="12" lg="6">
          <!--Carrousel -->
          <v-carousel show-arrows-on-hover cycle hide-delimiters height="600">
            <v-carousel-item
              v-for="(item,i) in items"
              :key="i"
              :src="item.src"
              reverse-transition="fade-transition"
              transition="fade-transition"
            ></v-carousel-item>
          </v-carousel>
          <!--Fin Carrousel -->
        </v-col>
      </v-row>
    </v-container>
    <!--Especificaciones Tecnicas-->
    <v-dialog v-model="dialog" max-width="1200" max-height="1200">
      <v-card class="pa-2">
        <v-card-title style="background: #EA296A">
          <p class="body-2 white--text my-auto mx-auto">{{titulos[0]}}</p>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-row class="mr-2">
            <v-col cols="4">
              <v-img :src="scrreginato[0]" align="center" :height="heightfoto[0]"></v-img>
            </v-col>
            <v-col cols="4">
              <v-row v-for="item in telescope" :key="item" align="stretch">
                <v-card outlined class="pa-2" style="width: 100%;">
                  <p class="text-center my-auto caption">{{item}}</p>
                </v-card>
              </v-row>
            </v-col>
            <v-col cols="4">
              <v-row v-for="item in especificaciones1" :key="item" align="stretch">
                <v-card outlined class="pa-2" style="width: 100%;">
                  <p class="text-center my-auto caption">{{item}}</p>
                </v-card>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card class="pa-2">
        <v-card-title style="background: #EA296A">
          <p class="body-2 white--text my-auto mx-auto">{{titulos[1]}}</p>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-row class="mr-2">
            <v-col cols="4">
              <v-img :src="scrreginato[1]" align="center" :height="heightfoto[1]"></v-img>
            </v-col>
            <v-col cols="4">
              <v-row v-for="item in mount" :key="item" align="stretch">
                <v-card outlined class="pa-2" style="width: 100%;">
                  <p class="text-center my-auto caption">{{item}}</p>
                </v-card>
              </v-row>
            </v-col>
            <v-col cols="4">
              <v-row v-for="item in especificaciones2" :key="item" align="stretch">
                <v-card outlined class="pa-2" style="width: 100%;">
                  <p class="text-center my-auto caption">{{item}}</p>
                </v-card>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card class="pa-2">
        <v-card-title style="background: #EA296A">
          <p class="body-2 white--text my-auto mx-auto">{{titulos[2]}}</p>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-row class="mr-2">
            <v-col cols="4">
              <v-img :src="scrreginato[2]" align="center" :height="heightfoto[2]"></v-img>
            </v-col>
            <v-col cols="4">
              <v-row v-for="item in camera" :key="item" align="stretch">
                <v-card outlined class="pa-2" style="width: 100%;">
                  <p class="text-center my-auto caption">{{item}}</p>
                </v-card>
              </v-row>
            </v-col>
            <v-col cols="4">
              <v-row v-for="item in especificaciones3" :key="item" align="stretch">
                <v-card outlined class="pa-2" style="width: 100%;">
                  <p class="text-center my-auto caption">{{item}}</p>
                </v-card>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialog:false,
      heightfoto: ["400", "280", "280"],
      telescope:[
        "Primary mirror diameter",
        "Secondary mirror diameter",
        "Focal ratio",
        "Field of view",
        "Focal length"
      ],
      mount:[
        "Maximum load",
        "Material",
        "Transmission system",
        "Controller"
      ],
      camera:[
        "Resolution",
        "Pixel size",
        "Sensor size",
        "Full well capacity",
        "Cooling",
        "Dark signal doubling temperature"
      ],
      especificaciones1: ["705mm", "212mm", "f/3.1", "40mm", "2200mm"],
      especificaciones2: ["∼ 150kg", "Hardened and ground steel", "Backlash-free system", "Gemini Pulsar II"],
      especificaciones3: ["4007 (H) × 2671 (V) pixels", "9 μm (H) × 9 μm (V)", "37.25 mm × 25.70 mm", "60,000 e–", "Two stage Peltier", "~7 °C"],
      titulos: [
        "Telescope : Reginato T700",
        "Mount : Reginato custom",
        "Camera : Atik 11000 color"
      ],
      items: [
        {
          src: require("../assets/telescope_1.png")
        },
        {
          src: require("../assets/newton-2.png")
        },
        {
          src: require("../assets/newton-3.png")
        }
      ],
      scrreginato: [
        require("../assets/Reginato_specs/scope_reginato.jpg"),
        require("../assets/Reginato_specs/mount_reginato.jpg"),
        require("../assets/Reginato_specs/camera_reginato.jpg")
      ]
    };
  },
};
</script>